var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 16,
    viewBox: "0 0 16 16",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    fill: "rgb(88, 106, 218)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12.794269 6.50460919c-.6514059-2.31086213-2.7750395-4.00460919-5.294269-4.00460919-3.03756612 0-5.5 2.46243388-5.5 5.5 0 3.0375661 2.46243388 5.5 5.5 5.5.55228475 0 1 .4477153 1 1s-.44771525 1-1 1c-4.14213562 0-7.5-3.3578644-7.5-7.5 0-4.14213562 3.35786438-7.5 7.5-7.5 2.7817602 0 5.2098026 1.51444642 6.5046092 3.76382146v-2.74768931c0-.55101196.4466834-.9976954.9976954-.9976954s.9976954.44668344.9976954.9976954v5.98617244c0 .25533252-.0974061.51066504-.2922182.70547719-.1948122.19481215-.4501447.29221822-.7054772.29221822h-5.98617245c-.55101196 0-.9976954-.44668345-.9976954-.99769541s.44668344-.9976954.9976954-.9976954z",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRefresh);
export default __webpack_public_path__ + "static/media/icon-refresh.194e7a654be9d9ff2fca62296c608268.svg";
export { ForwardRef as ReactComponent };